import { convertGridToPixels } from "../../../Pages/FlexibleLayout/utils";
import { newProcessLayout } from "../../GridLayoutFunc";
import { getLayoutDataOfDetailviewElements } from "../../InitialRenderingData";

export const getInitialConfigForDetailsview = (config, options) => {
  let positionLayoutConfig;

  const dvConfig = JSON.parse(JSON.stringify(config));
  const elementsLayout = getLayoutDataOfDetailviewElements(dvConfig.data.elements || [], options.tableData);
  const { layout, layoutData, nestedGridData } = elementsLayout;
  let { elements } = newProcessLayout(layoutData, nestedGridData, layout);
  dvConfig.data.elements = elements;

  if (config.device === "mobile") {
    positionLayoutConfig = convertGridToPixels(
      config.position_block_config || [],
      config.position_block_metadata?.grid_size || 4
    );
  }

  return { config: dvConfig, options: { elementsLayout, positionLayoutConfig } };
};
